'use client'

import { SnackbarProvider } from 'notistack'
import React from 'react'

import { Snackbar } from './Snackbar'

interface AppSnackbarProviderProps {
  children: React.ReactNode
  maxSnack?: number
}

export const AppSnackbarProvider = ({
  children,
  maxSnack = 1,
}: AppSnackbarProviderProps) => {
  const notistackRef = React.createRef<SnackbarProvider>()
  return (
    <SnackbarProvider
      Components={{
        default: Snackbar,
        error: Snackbar,
        info: Snackbar,
        success: Snackbar,
        warning: Snackbar,
      }}
      ref={notistackRef}
      maxSnack={maxSnack}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      autoHideDuration={6000}
      transitionDuration={{ enter: 300, exit: 300 }}
      TransitionProps={{
        direction: 'down',
      }}
    >
      {children}
    </SnackbarProvider>
  )
}
